import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import User from '../../../helpers/user'

class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company: props.company,
            index: props.index,
        }
    }

    getModuleProcessedItem(module) {
        for (let i in this.state.company.modules) {
            if (this.state.company.modules[i].code === module.code) {
                return this.state.company.modules[i].processedItemCount + ' db';
            }
        }
        return '-';
    }

    render() {
        return (
            <tr>
                <td>{parseInt(this.state.index) + 1},</td>
                <td>{this.state.company.name}</td>
                <td className='text-center'>{this.state.company.lastProcessedDate || ''}</td>
                {User.requireUser().enabledModules.map((module) => {
                    return <td className='text-center' key={'company-row-cell-' + Math.random(9999, 99999)}>
                        {this.getModuleProcessedItem(module)}
                    </td>
                })}
                <td className='float-md-right'>
                    {this.state.company.modules.map(
                        (module) => <Link key={this.state.company.name + '-' + module.code} className={'btn btn-sm ' + (module.processedItemCount > 0 ? 'table-green-btn' : 'table-gray-btn')} to={`start/${module.code}/${this.state.company.id}`} style={{marginLeft: '1px'}}>
                            {module.name}
                        </Link>
                    )}
                    <a className='btn btn-sm table-green-btn' onClick={() => this.props.edit(this.state.company)} style={{marginLeft: '1px'}}><i className="fa fa-pencil-square-o" aria-hidden="true"/></a>
                    <a className='btn btn-sm table-green-btn' onClick={() => this.props.delete(this.state.company.id)} style={{marginLeft: '1px'}}><i className="fa fa-trash-o" aria-hidden="true"/></a>
                </td>
            </tr>
        )
    }

}

export default List


// WEBPACK FOOTER //
// ./src/components/company/Table/List.js